import React from 'react';

import { SectionCard } from '~components';
import Icon, { faInfoCircle } from '~components/icon';

import { colourStack } from '../utils';
import { Category, CategoryDatum } from './Category';

interface CategoryItem {
  title: string;
  categoryId: string;
  total: number;
  value: number;
  color: string;
  utilisation: number;
  data: {
    label: string;
    value: number;
    color: string;
  }[];
}

interface CategoryBreakdownProps {
  items: CategoryItem[];
}

const CategoryBreakdown: React.FC<CategoryBreakdownProps> = ({ items }) => {
  const categoryAllocationsData: CategoryDatum[] = items
    ? items.map(({ title, value }, index) => {
        return {
          label: title,
          value,
          color: colourStack[3 + (index % (colourStack.length - 3))],
        };
      })
    : [];

  return (
    <SectionCard title="Category Breakdown" description="Allocation and consumption by Contribution Category">
      {items.length > 0 ? (
        <div className="category-breakdown-row">
          <div key="category-allocation" className="category-breakdown-col">
            <Category data={categoryAllocationsData} title="Category Allocation" showTotal={false} color="#000000ff" />
          </div>
          {items.map((item) => (
            <div key={item.categoryId} className="category-breakdown-col">
              <Category
                data={item.data}
                title={item.title}
                showTotal
                catergoryTotal={item.total}
                color={item.color}
                utilisation={item.utilisation}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="no-data-message">
          <Icon icon={faInfoCircle} />
          No categories included in the budget.
        </div>
      )}
    </SectionCard>
  );
};

export default CategoryBreakdown;
